import Adobe from "./providers/adobe";
import Facebook from "./providers/facebook";
import Google from "./providers/google";

const pixelDb = {
  triggers: {
    ON_ROUTE: {
      landing: [],
      paso1: ["Facebook.paso1", "Google.paso1", "Adobe.paso1"],
      gracias: ["Facebook.gracias", "Google.gracias", "Adobe.thank"],
      mensaje: ["Facebook.mensaje", "Google.mensaje", "Adobe.mensaje"]
    },
    ON_ADOBE_APPSTARTED: ["Adobe.clickTracking"],
    onClickTracking: ["Adobe.clickTracking"]
  },
  providers: {
    Facebook,
    Google,
    Adobe
  }
};

export default pixelDb;
